export default __webpack_public_path__ + "static/media/nervous-system.7b1a280a.png";